import http from './http'

export function getUserApi(token, apiVersion) {
	let url = apiVersion === 'v2' ? 'rest/user/me' : '/rest/users/me'
	return http({
		headers: {
			authorization: `Bearer ${token}`
		},
		method: 'GET',
		url: url
	})
}
export function getJson(token, lang) {
	return http({
		method: 'GET',
		url: `/${lang}/platform/json/trading-platform${token ? '?access_token='+token : ''}`

	})
}
export function deleteMsg(id, token) {
	return http({
		headers: {
			authorization: `Bearer ${token}`
		},
		method: 'GET',
		url: `/rest/users/messages/deletes/my?id=${id}`

	})
}
export function getMsgs(token) {
	return http({
		headers: {
			authorization: `Bearer ${token}`
		},
		method: 'GET',
		url: '/rest/users/messages/my'
	})
}
export function setTheme(theme, token) {
	return http({
		headers: {
			authorization: `Bearer ${token}`
		},
		method: 'GET',
		url: `rest/users/me?theme=${theme}`

	})
}
